<template>
  <v-toolbar fixed app :class="isMobile? 'mobile' : ''">
    <v-toolbar-side-icon @click.stop="togNav()"></v-toolbar-side-icon>
    <router-link to='/' class="title home-link" :class="isMobile ? 'py-2 px-1' : 'pa-3 '"
                 title="Gehe zur Startseite" @click="scrollTop()">
      <img v-if="$route.path ==='/'" src="/static/tec-logo-schrift-white.svg" alt="Logo TEC">
      <img v-else src="/static/tec-logo-schrift.svg" alt="Logo TEC">
    </router-link>
    <notifications class="" :isMobile="isMobile" :show-notifications="showNotifications"></notifications>
    <router-links-list class="router-links-top-list" :isMobile="isMobile"></router-links-list>
    <v-spacer v-if="!isMobile"></v-spacer>
    <log-in-out></log-in-out>
  </v-toolbar>
</template>
<script>
  import RouterLinksList from "./components/RouterLinks";
  import LogInOut from "./components/LogInOut";
  import Notifications from "../../content/notifications/Notifications";
  import {mapGetters} from 'vuex';

  export default{
    components: {
      Notifications,
      LogInOut,
      RouterLinksList,
    },
    computed: {
      ...mapGetters(['isMobile'])
    },
    name: 'top-nav',
    props: [
      'sideNav', 'showNotifications'
    ],
    data () {
      return {
      };
    },
    methods: {
      scrollWin(){
        window.scrollTo(0, this.$helper.findPos(document.getElementById('news-container')) - 100);
      },
      scrollTop() {
        setTimeout(()=>{
          window.scrollTo(0,0)
          // console.log('scroll')
        },1000)

      },
      togNav () {
       this.$emit('toggleNav')
      },
    }
  };
</script>
<style lang="scss">
  a.home-link {
    &.router-link-exact-active:not(.left-nav) {
      background-image: linear-gradient(to bottom right, #333232, darkgrey);
    }
    position: relative;
    width: 63px;
    height: 55px;
    img {
      position: absolute;
      left: -4.5px;
      top: -7px;
      width: 70px;
    }
  }

  .toolbar__title a, .router-link-active{
    text-decoration: none;
  }
  .router-links-top-list{
    height: 100%;
   .router-link-active:not(.left-nav), .top-nav-link {
      padding-top:20px;
      &.club{
        padding-top:17px;
      }
    }
  }
</style>
